import useSWR from "swr";

export const useFetchLineRegistrationTrends = (restaurantId: string, startDate: string|null, endDate: string|null) => {
  const { data: lineRegistrationTrends, error, isLoading } = useSWR<Record<string, number>>(`external_api/restaurants/${restaurantId}/line/registration-trends/?startDate=${startDate}&endDate=${endDate}`)
  return { lineRegistrationTrends, isLoading, error };
};